import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import {
  Agent,
  AgentsSort,
  ICreateAgentParams,
  IGetAgentResponse,
  IGetAgentsListResponse,
  IGetAgentsResponse,
} from './interfaces';
import {
  IDeleteResourceResponse,
  IUpsertResourceResponse,
} from '../interfaces';
import { getPaginatedEndpointParams } from '../helpers';
import { FilterFields } from '../../components/ManagedDataTable/interfaces';

export const getAgent = async (id: number): Promise<Agent> => {
  const response: AxiosResponse<IGetAgentResponse> = await apiClient.get(
    `/agents/${id}`
  );

  return response.data.data;
};

export const deleteAgent = async (id: number): Promise<void> => {
  const response: AxiosResponse<IDeleteResourceResponse> =
    await apiClient.delete(`/agents/${id}`);
};

export const getAgents = async (
  page: number,
  pageSize: number,
  sort?: AgentsSort,
  search?: string,
  filters?: FilterFields
): Promise<IGetAgentsResponse> => {
  const response: AxiosResponse<IGetAgentsResponse> = await apiClient.get(
    '/agents',
    {
      params: getPaginatedEndpointParams({
        page,
        perPage: pageSize,
        sort,
        search,
        filters,
      }),
    }
  );

  return response.data;
};

export const getAgentsList = async (): Promise<Agent[]> => {
  const response: AxiosResponse<IGetAgentsListResponse> = await apiClient.get(
    '/agents/list'
  );

  return response.data.data;
};

export const getClientAgentsList = async (
  clientId: number
): Promise<Agent[]> => {
  const response: AxiosResponse<IGetAgentsListResponse> = await apiClient.get(
    `/clients/${clientId}/agents/list`
  );

  return response.data.data;
};

export const createAgent = async (
  agentData: ICreateAgentParams
): Promise<number> => {
  const formData = new FormData();

  Object.entries(agentData).forEach(([key, value]) => {
    formData.append(key, value as string);
  });

  const response: AxiosResponse<IUpsertResourceResponse> = await apiClient.post(
    '/agents/',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data.data.id;
};

export const updateAgent = async (
  agentId: number,
  agentData: ICreateAgentParams
): Promise<number> => {
  const formData = new FormData();

  Object.entries(agentData).forEach(([key, value]) => {
    formData.append(key, value as string);
  });

  formData.append('_method', 'PUT');

  const response: AxiosResponse<IUpsertResourceResponse> = await apiClient.post(
    `/agents/${agentId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data.data.id;
};
